import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveFuelTypeRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-fule-type',
  templateUrl: './fule-type.component.html',
  styleUrls: ['./fule-type.component.scss']
})
export class FuleTypeComponent implements OnInit {
  modalRef: BsModalRef;
  public itemVm: SaveFuelTypeRequest = new SaveFuelTypeRequest();
  public vmListItems: any = [];
  public component_Title = "Fuel Type";
  public deleteId: string;

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }

  ngAfterViewInit() {
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetFuelTypesAsync().subscribe((res: any) => {
      this._jq.reinitDataTable(res.result);
      this.vmListItems = res.result;
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveFuelTypeRequest();
    }
  }


  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.DeleteFuelTypeAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }


  // extrnal components
  onItemSubmitted(e) {
    debugger
    console.log(e);
    if (e === true) {
      this.itemVm = new SaveFuelTypeRequest();
      this.getList();
    }
  }
}
